<template>
  <div class="page">
    <div class="div-header-select">
      <div class="div-center">
        <div>账单时间：</div>
        <el-date-picker
          style="width: 250px"
          size="medium"
          v-model="daterange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
      <div class="div-center" style="margin-left: 85px">
        <span>付款信息：</span>
        <el-button size="medium" @click="showDialogUpload">导入</el-button>
      </div>
    </div>
 

    <main>
      <el-table :data="listData" style="width: 100%">
        <template slot="empty">
          <img
            src="../../assets/list-none.png"
            alt=""
            width="400"
            class="table-empty"
          />
          <div>空荡荡的～暂无数据！</div>
        </template>
        <el-table-column prop="tradeDate" label="交易日期" align="center">
        </el-table-column>
        <el-table-column prop="jie" label="借" align="center">
        </el-table-column>
        <el-table-column prop="dai" label="贷" align="center">
        </el-table-column>
        <el-table-column prop="balance" label="余额" align="center">
        </el-table-column>
        <el-table-column prop="banNumber" label="对方账号" align="center">
        </el-table-column>
        <el-table-column prop="name" label="对方户名" align="center">
        </el-table-column>
        <el-table-column prop="cause" label="渠道标志" align="center">
        </el-table-column>
        <el-table-column prop="digest" label="摘要" align="center">
        </el-table-column>
        <el-table-column prop="comment" label="备注" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="danger"
              icon="el-icon-delete"
              plain
              size="mini"
              @click="deleteItem(scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </main>

    <footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIdx"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="itemTotal"
        :page-sizes="[10, 20, 30, 40, 50]"
      >
      </el-pagination>
    </footer>
     <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogUploadVisible"
      :before-close="uploadClose"
      title="批量导入数据"
      width="50%"
    >
      <file-upload type="银行账单信息导入" ></file-upload>
    </el-dialog>
  </div>
</template>

<script>
let interval;
import axios from "axios";
import Utils from "../../Utils";
import FileUpload from "./FileUpload";
import { Loading } from "element-ui";
import { Decimal } from "decimal.js";
import mixins from "../../minix";

let _vue;

export default {
  mixins: [mixins],
  components: { FileUpload },
  name: "home",

  data() {
    return {
      daterange: "",
      pageIdx: 0,
      isDle:false,
      isEdit:false,
      precision:2,//收费项目金额预留小数点位数
      itemTotal: 0,
      title:'新增',
      queryPhone:'',
      dialogUploadVisible: false,
      dialogUploadFile: "",
      dialogVisible: false,
      pricingDialogVisible: false,
      listData: [],
      pricingList: [],
      pricing: {},
      name: "",
      pricings: [],

      dialogTopupVisible: false,
      house:{
        id:'',
        name:'',
        areaName:'',
      },
      formInput: {
      }
    };
  },

  created() {
    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", "Web_Admin");

    this.query(0);
    _vue = this;
  },

  watch: {
    daterange() {
      this.initQuery();
    },
    state() {
      this.initQuery();
    },

    areaIDSelect() {
      this.initQuery();
    }
  },

  methods: { 
    async showDialogUpload() {
      this.dialogUploadVisible = true;
    },
    
    uploadClose(done) {
      clearInterval(interval);
      this.pageIdx = 0;
      this.query(0);
      done();
    },
    handleCurrentChange(val) {
      this.pageIdx = val;
      this.query(val - 1);
    },

    querySearch(queryString, cb) {
      cb(this.areasList);
    },

    handleSizeChange(val) {
      this.pageIdx = 0;
      this.pageSize = val;
      this.query(0);
    },

    
    deleteItem(item) {
      let _vue = this;
      this.$confirm(
        `是否删除该记录？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        axios({
          method: "post",
          url: "banks/records/delete",
          data: {
            id: item.id,
            name: item.name
          }
        })
          .then(value => {
             if (value.data.code === 0) {
              this.$message.success(value.data.message);
            } else {
              this.$message.error(value.data.message);
            }
          })
          .finally(() => {
          if (this.listData.length==1){
            _vue.query(_vue.pageIdx - 2);
          }else{
          _vue.query(_vue.pageIdx - 1);
          }
          });
      });
    },


    initQuery() {
      this.pageIdx = 0;
      this.query(0);
    },

    //列表查询
    query(pageIdx) {
      if (pageIdx <= 0) {
        pageIdx = 0;
      }

      let data = {
        pageSize: this.pageSize,
        pageIdx: pageIdx,
      };
      if (Array.isArray(this.daterange)) {
        data.start = parseInt(this.daterange[0].getTime() / 1000);
        data.end = parseInt(
          this.daterange[1].getTime() / 1000 + 60 * 60 * 24 - 1
        );
      }
      const loading = Loading.service({
        lock: true,
        text: "加载列表中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });

      axios({
        method: "post",
        url: "banks/records",
        data: data
      })
        .then(value => {
          this.listData = [];
          if(value.data.code!=0){
            this.$message.error(value.data.message);
            return
          }
          this.itemTotal = value.data.total;
          if (value && value.data && value.data.data) {
           this.listData= value.data.data
          }
          
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });
    }
  }
};
</script>

<style>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.el-input-group__prepend {
  width: 140px !important;
}
.el-input-group--prepend {
  margin-bottom: 10px;
}
</style>

<style lang="scss" scoped>
@import "../../style.css";
main {
  margin-top: 10px;
}
.div-2-title {
  max-width: 80px;
  min-width: 70px;
}
</style>